export default {
  isMore: (state) => {
    const count = state.data.length;
    const total = state.total;

    if (total - count > 0) return true;
    return false;
  }
};
